// extracted by mini-css-extract-plugin
export default {"cont":"Home_cont__ssEv5","side_menu":"Home_side_menu__23-8D","content_list":"Home_content_list__M9e-n","title":"Home_title__5eO91","text":"Home_text__Tc-jz"};